import { m } from 'framer-motion';
import React, { useState } from 'react';
import './homepage.css'
import { Grid, Container, Typography, Box, Button, Stack, Dialog, DialogContent, IconButton, DialogActions } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { styled } from "@mui/material/styles";
import { useResponsive } from '../../hooks/use-responsive';
import { MotionViewport, varFade, } from '../animate';


function CreateYourOwnCloud() {
    const mdUp = useResponsive('up', 'md');
    const navigate = useNavigate();
    const ExplorePricing = styled(Button)(({ theme }) => ({
        backgroundColor: "#C7F760",
        color: "#1E53E8",
        // padding: "6px 35px",
        fontFamily: "Roboto Flex",
        fontSize: "18px",
        fontWeight: 700,
        textTransform: "none",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#1E53E8",
            color: "#C7F760",
        },

    }));
    const WatchVideo = styled(Button)(({ theme }) => ({

        fontFamily: "Roboto Flex",
        fontSize: "18px",
        fontWeight: 700,
        textTransform: "none",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#C7F760",
            color: "#1E53E8",
        },

    }));
    const [openVideo, setOpenVideo] = useState(false);

    const handleOpenVideo = () => {
        console.log("Button clicked");
        setOpenVideo(true);
    };

    const handleCloseVideo = () => {
        console.log("Button false");
        setOpenVideo(false);
    };
    return (
        <Container maxWidth={false} sx={{
            position: 'relative', mb: 3,
            backgroundImage: 'url("/assets/CreateYourOwn_bg.svg")',
            backgroundSize: "cover", // Adjust as needed
            backgroundPosition: "center", // Adjust as needed
        }} component={MotionViewport}  >

            <Box sx={{

                paddingTop: '40px',
                paddingBottom: '40px',
                borderRadius: '8px',

            }}>
                <Grid spacing={2} alignItems="center">
                    <m.div variants={varFade({ distance: 120, durationIn: 0.9 }).inUp} >
                        {mdUp && <Typography variant="h3" className="heading3" fontWeight="bold"
                            paddingBottom='10px' textAlign='center' component="div" gutterBottom>
                            CREATE YOUR OWN CLOUD  COMPUTER IN 4 EASY STEPS WITH<br />
                            <span style={{ color: '#1E53E8', fontStyle: 'italic' }} > MEGACONNECT</span>
                        </Typography>}
                        {!mdUp && <Typography variant="h4" className="heading3" marginTop={1} fontWeight="bold"
                            paddingBottom='10px' textAlign='center' component="div" gutterBottom>
                            CREATE YOUR OWN CLOUD  COMPUTER IN 4 EASY STEPS WITH
                            <span style={{ color: '#1E53E8', fontStyle: 'italic' }} > MEGACONNECT</span>
                        </Typography>}
                    </m.div>
                    <m.div variants={varFade({ distance: 120, durationIn: 0.9 }).inUp}>
                        <Box sx={{
                            display: 'grid',
                            rowGap: 5,
                            columnGap: 2,
                            padding: { sm: '0 6px' },
                            mt: 8,

                            gridTemplateColumns: {
                                xs: "repeat(1, 1fr)",   // iPhone Mini (small screens)
                                sm: "repeat(1, 1fr)",   // For screens like iPad mini (768px)
                                md: "repeat(4, 1fr)",
                            },
                        }}>

                            <Box
                                sx={{
                                    position: 'relative',
                                    border: '3px #1D53E7 solid',
                                    backgroundColor: '#ffffff', // Light blue background color
                                    borderRadius: '15px',
                                    padding: '16px',
                                    textAlign: 'center', // Center the content
                                    pb: 4,

                                }}

                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '-30px', // Adjust to position the circle
                                        right: '50%', // Center horizontally
                                        transform: 'translateX(50%)', // Center horizontally
                                        width: '50px',
                                        height: '50px',
                                        backgroundColor: '#1E53E8', // Yellow circle
                                        borderRadius: '50%',
                                        border: "5px solid #C7F760 ",
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Typography variant="h4" sx={{ color: '#C7F760', fontFamily: 'Roboto Flex !important', fontWeight: 700 }}>
                                        1
                                    </Typography>
                                </Box>
                                <Typography variant="h6" className='subTitle2' color='#1E53E8' gutterBottom mt={4}>
                                    Select Your Plan
                                </Typography>
                                <Typography variant="body1" className='textfont' fontSize='14px' textAlign='center' >
                                    Choose the plan that best suits your needs based on features and performance.<br /> <br />
                                </Typography>
                            </Box>


                            <Box
                                sx={{
                                    position: 'relative',
                                    border: '3px #1D53E7 solid',
                                    backgroundColor: '#ffffff', // Light blue background color
                                    borderRadius: '15px',
                                    padding: '16px',
                                    textAlign: 'center', // Center the content
                                    pb: 4,
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '-30px', // Adjust to position the circle
                                        right: '50%', // Center horizontally
                                        transform: 'translateX(50%)', // Center horizontally
                                        width: '50px',
                                        height: '50px',
                                        backgroundColor: '#1E53E8', // Yellow circle
                                        borderRadius: '50%',
                                        border: "5px solid #C7F760 ",
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Typography variant="h4" sx={{ color: '#C7F760', fontFamily: 'Roboto Flex !important', fontWeight: 700 }}>
                                        2
                                    </Typography>
                                </Box>
                                <Typography variant="h6" className='subTitle2' color='#1E53E8' gutterBottom mt={4}>
                                    Download
                                </Typography>
                                <Typography variant="body1" className='textfont' fontSize='14px' textAlign='center' >
                                    Download and install the App on your local computer.<br /> <br />
                                </Typography>
                            </Box>


                            <Box
                                sx={{
                                    position: 'relative',
                                    border: '3px #1D53E7 solid',
                                    backgroundColor: '#ffffff', // Light blue background color
                                    borderRadius: '15px',
                                    padding: '16px',
                                    textAlign: 'center', // Center the content
                                    pb: 4,
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '-30px', // Adjust to position the circle
                                        right: '50%', // Center horizontally
                                        transform: 'translateX(50%)', // Center horizontally
                                        width: '50px',
                                        height: '50px',
                                        backgroundColor: '#1E53E8', // Yellow circle
                                        borderRadius: '50%',
                                        border: "5px solid #C7F760 ",
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Typography variant="h4" sx={{ color: '#C7F760', fontFamily: 'Roboto Flex !important', fontWeight: 700 }}>
                                        3
                                    </Typography>
                                </Box>
                                <Typography variant="h6" className='subTitle2' color='#1E53E8' gutterBottom mt={4}>
                                    Log In and Get Started
                                </Typography>
                                <Typography variant="body1" className='textfont' fontSize='14px' textAlign='center' >
                                    Access your MegaConnect Cloud portal and log in using your credentials.<br /> <br />
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    position: 'relative',
                                    border: '3px #1D53E7 solid',
                                    backgroundColor: '#ffffff', // Light blue background color
                                    borderRadius: '15px',
                                    padding: '16px',
                                    textAlign: 'center', // Center the content
                                    pb: 4,
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '-30px', // Adjust to position the circle
                                        right: '50%', // Center horizontally
                                        transform: 'translateX(50%)', // Center horizontally
                                        width: '50px',
                                        height: '50px',
                                        backgroundColor: '#1E53E8', // Yellow circle
                                        borderRadius: '50%',
                                        border: "5px solid #C7F760 ",
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Typography variant="h4" sx={{ color: '#C7F760', fontFamily: 'Roboto Flex !important', fontWeight: 700 }}>
                                        4
                                    </Typography>
                                </Box>
                                <Typography variant="h6" className='subTitle2' color='#1E53E8' gutterBottom mt={4}>
                                    Access Dashboard
                                </Typography>
                                <Typography variant="body1" className='textfont' fontSize='14px' textAlign='center' >
                                    Install the on-demand application and get started.<br /> <br />
                                </Typography>
                            </Box>
                        </Box>
                    </m.div>

                    <Stack direction='row' spacing={2} justifyContent='center' alignItems='center' sx={{ pt: 5, pb: 6 }}>
                        <Grid container md={3} justifyContent='center' alignItems='center' component={m.div}
                            variants={varFade({ distance: 120, durationIn: 0.9 }).inUp} >
                            <ExplorePricing
                                onClick={() => navigate('/plans#details')}
                                variant="contained"
                                fullWidth
                                size="large"
                                sx={{
                                    color: "#1E53E8",
                                    fontWeight: "bold",
                                    background: "#C7F760",
                                    padding: 1,
                                    borderRadius: 2,
                                }}
                            >
                                Explore Pricing
                            </ExplorePricing>

                        </Grid>
                        <Grid container md={3} justifyContent='center' alignItems='center' component={m.div}
                            variants={varFade({ distance: 120, durationIn: 0.9 }).inUp} >
                            <WatchVideo
                                size="large"
                                fullWidth
                                sx={{
                                    fontWeight: "bold",
                                    padding: 1,
                                    borderRadius: 2,
                                    backgroundColor: "transparent",
                                    transition: "background-color 0.3s ease",
                                    border: "2px solid #C7F760", // Add 5px border with the specified color


                                }}
                                onClick={handleOpenVideo}
                            >
                                Watch Video
                            </WatchVideo>

                        </Grid>
                    </Stack>
                </Grid>


            </Box>
            <Dialog
                open={openVideo}
                onClose={handleCloseVideo}
                fullWidth
                maxWidth="lg"
                sx={{
                    '& .MuiDialog-paper': {
                        width: { md: '720px', xs: '100%' }, // 720px on desktop, full width on mobile
                        maxWidth: { xs: '720px', md: 'none' }, // Prevents overflow on small screens
                        borderRadius: 5,
                        pb: 2,
                    }
                }}
            >
                <DialogActions>
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseVideo}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogActions>
                <DialogContent sx={{ padding: '10px', paddingTop: '38px' }}>
                    <Box
                        sx={{
                            position: 'relative',
                            width: '100%',
                            paddingTop: { md: '56.25%', xs: '75%' }, // 16:9 aspect ratio for desktop, 4:3 for mobile
                            overflow: 'hidden',
                            borderRadius: 3,
                        }}
                    >
                        <iframe
                            src="https://www.youtube.com/embed/nPOu6gsrlSs?si=EiQ5l1Nz_TnvXm74"
                            title="How to Set Up a Secure, High-Speed Cloud PC in 2024"
                            frameBorder="0"
                            overflow='auto'
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                            }}
                        />
                    </Box>
                </DialogContent>
            </Dialog>

        </Container>
    );
}

export default CreateYourOwnCloud;
